import { createAction } from '@mews/framework';
import { ApplicationState, Preauthorization } from '@mews-commander/types';
import prefix from '../prefix';
import parentSelector from '../selector';
import { createScopedBaseEntitySelectors, createScopedEntitiesReducer } from './utils';

export const NAME = 'preauthorizations';

const PREAUTHORIZATIONS_LOADED = prefix('PREAUTHORIZATIONS_LOADED');
const PREAUTHORIZATION_LOADED = prefix('PREAUTHORIZATION_LOADED');

export const setPreauthorizations = (preauthorizations: Preauthorization[], customerId?: string) =>
    createAction(PREAUTHORIZATIONS_LOADED, { entities: preauthorizations }, { scope: customerId });
export const setPreauthorization = (preauthorization: Preauthorization, customerId?: string) =>
    createAction(PREAUTHORIZATION_LOADED, preauthorization, { scope: customerId });

export const [getPreauthorizations, getPreauthorizationsByIds, getPreauthorizationsByOwnerId, getPreauthorization] =
    createScopedBaseEntitySelectors<ApplicationState, Preauthorization, typeof NAME, 'ownerId'>(
        parentSelector,
        NAME,
        'ownerId'
    );

export default createScopedEntitiesReducer({
    FETCH_SUCCESS: PREAUTHORIZATIONS_LOADED,
    ADD_SUCCESS: PREAUTHORIZATION_LOADED,
});
